import React from "react";
import { EXHIBITIONS } from "../data/site";
import { MapPin, ExternalLink } from "lucide-react";

export default function CurrentlyShowing() {
  return (
    <section
      className="border-t border-border bg-[hsl(var(--surface))]"
      data-testid="currently-showing"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20 md:py-28">
        <header className="mb-12 md:mb-16">
          <p className="label mb-3">002 — Currently Showing</p>
          <h2 className="serif text-4xl md:text-5xl tracking-tight font-light">
            On view now.
          </h2>
        </header>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-10">
          {EXHIBITIONS.current.map((ex) => (
            <article
              key={ex.id}
              className="bg-background border border-border p-6 md:p-8"
              data-testid={`current-${ex.id}`}
            >
              <div className="aspect-[4/3] overflow-hidden bg-[hsl(var(--surface))] mb-6 flex items-center justify-center p-4">
                <img
                  src={ex.image}
                  alt={ex.title}
                  className="max-w-full max-h-full w-auto h-auto object-contain"
                />
              </div>
              <div className="flex items-center gap-3 mb-3">
                {ex.badge && (
                  <span
                    className="inline-block bg-foreground text-background px-3 py-1 text-[0.625rem] uppercase tracking-[0.18em]"
                    data-testid={`badge-${ex.id}`}
                  >
                    {ex.badge}
                  </span>
                )}
                <span className="label">{ex.meta}</span>
              </div>
              <h3 className="serif text-3xl md:text-4xl tracking-tight">
                {ex.title}
              </h3>
              <p className="mt-3 text-[hsl(var(--ink-soft))] leading-relaxed">
                {ex.blurb}
              </p>
              <div className="mt-6 flex items-center gap-2 text-sm text-[hsl(var(--ink-soft))]">
                <MapPin className="h-3.5 w-3.5" />
                <span>{ex.location}</span>
              </div>
              {ex.link && (
                <a
                  href={ex.link}
                  target="_blank"
                  rel="noreferrer"
                  className="mt-4 inline-flex items-center gap-2 label link-underline text-foreground"
                  data-testid={`current-link-${ex.id}`}
                >
                  Plan a visit <ExternalLink className="h-3 w-3" />
                </a>
              )}
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
